export default __webpack_public_path__ + "static/media/filter.599a41b5.svg";